exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Expenses_tabsList_mIHZ {\n  margin-left: auto;\n\n  width: auto\n}\n\n.Expenses_tabsList_mIHZ .Expenses_tabName_2sOm {\n  font-size: 17px;\n}\n\n.Expenses_tabsList_mIHZ .Expenses_tab_1iM8 {\n  max-width: none !important;\n}\n\n.Expenses_preloader_3Xmk {\n  position: static;\n  margin: 75px auto 35px;\n\n  display: block !important;\n\n  -webkit-transform: none;\n\n          transform: none;\n}\n\n.Expenses_status_2NVh {\n  margin-top: 20px;\n\n  max-width: none;\n}\n\n.Expenses_expensesFilters_k9TR {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n}\n", ""]);

// exports
exports.locals = {
	"tabsList": "Expenses_tabsList_mIHZ",
	"tabName": "Expenses_tabName_2sOm",
	"tab": "Expenses_tab_1iM8",
	"preloader": "Expenses_preloader_3Xmk",
	"status": "Expenses_status_2NVh",
	"expensesFilters": "Expenses_expensesFilters_k9TR"
};